// export const API_BASE_URL = 'http://localhost:3045/api/';
export const API_BASE_URL = 'https://apiv2.tycoonland.nyc/api/';


export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/users/login`
  },
  PROPERTY: {
    CHECK_DETAILS: (elementId: string) => `${API_BASE_URL}/properties/checkPropertyDetails?text=${elementId}`,
  }
};

interface ApiResponse<T> {
  apiId?: string;
  statusCode: number;
  message: string;
  data: T;
}

export const fetchApi = async <T>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> => {
  try {
    const response = await fetch(endpoint, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw {
        response: {
          data: data
        }
      };
    }

    return data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
}; 